// extracted by mini-css-extract-plugin
export default {"slideStyling":"TitleSlide_slideStyling__TU9Ul","titleSlide":"TitleSlide_titleSlide__HsZ5K"};